import { render, staticRenderFns } from "./RequestVerificationEmail.vue?vue&type=template&id=d2c29604&scoped=true"
import script from "./RequestVerificationEmail.vue?vue&type=script&lang=js"
export * from "./RequestVerificationEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c29604",
  null
  
)

export default component.exports